const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 04/01/17.
 */
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const classnames = require('classnames');
require('./ContractRiskButtonGroup.scss');

const ContractRiskButtonGroup = props => {
    const { lowRisk, highRisk, risk } = props;

    if (lowRisk > highRisk) {
        throw new Error('The low risk value should be less than higher risk');
    }
    let buttons=[];
    for (let x= lowRisk; x<=highRisk; x++) {
        const buttonClass = classnames('contract-risk-button-group__button', {
            'contract-risk-button-group__selected-risk': risk === x
        });
        buttons.push(<button className={buttonClass}>{x}</button>);
    }
    return (
        <div className="contract-risk-button-group">
            <h4><FormattedText value="contractsView-contractRiskButtonGroupRiskLabel"/></h4>
            <div className="contract-risk-button-group__horizontal-buttons">
                {buttons}
                <div className="labels">
                    <div className="contract-risk-button-group__minor-risk-label">
                        <FormattedText value="contractsView-contractRiskButtonGroupLowerRiskLabel"/>
                    </div>
                    <div className="contract-risk-button-group__higher-risk-label">
                        <FormattedText value="contractsView-contractRiskButtonGroupGreaterRiskLabel"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

ContractRiskButtonGroup.propTypes = {
    lowRisk: PropTypes.number,
    highRisk: PropTypes.number,
    risk: PropTypes.number
};

module.exports = ContractRiskButtonGroup;